import type { AnchorDraftClassification } from './classifyAnchorDrafts';

export interface AnchorImportPayload<TData> {
  /** Rows to create — all drafts on a fresh import, only the appended ones on a delta. */
  rows: TData[];
  /** In-place edits of seeded rows, matched by `_id` (ADR 0011, second amendment). */
  updates?: Array<TData & { _id: string }>;
  /** Surgical deletions of seeded rows by `_id` (ADR 0011, third amendment). */
  removals?: string[];
}

/**
 * Translates the classified delta into the wire shape both anchor imports
 * share: new rows plus id-matched updates and removals. A fresh import
 * classifies every draft as new, so its payload is all-creates.
 */
export function buildAnchorImportPayload<TRow extends { data: object; entityId?: string }>(
  classification: Extract<AnchorDraftClassification<TRow>, { kind: 'delta' }>
): AnchorImportPayload<TRow['data']> {
  return {
    rows: classification.newRows.map((row) => row.data),
    ...(classification.updatedRows.length > 0 && {
      updates: classification.updatedRows.map((row) => ({ _id: row.entityId, ...row.data }))
    }),
    ...(classification.removedIds.length > 0 && { removals: classification.removedIds })
  };
}
